import { render, staticRenderFns } from "./NormalSearchNav361.vue?vue&type=template&id=faba07be&scoped=true"
import script from "./NormalSearchNav361.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav361.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faba07be",
  null
  
)

export default component.exports